import { SearchParams } from './search-params.modal';

export class SearchDocType extends SearchParams<string> {
    controlType = 'doctype'

    constructor(options: {} = {}) {
        super(options)
    }
}